module.exports = __webpack_public_path__ + "img/rules_engine_option_2.38d95594.png";